"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InitialTableState = void 0;
var InitialTableState = exports.InitialTableState = {
  selectedProduct: undefined,
  selectedOptions: undefined,
  activeProductGroup: undefined,
  visiblePlans: undefined,
  filteredQuotes: undefined,
  staffMode: false,
  petSureStaffMode: false,
  productQuotes: undefined,
  quotesContext: undefined,
  productsAreMerged: true,
  groupDisplayStates: {},
  dataIsUpdating: false,
  mobileSettings: {
    mobileMode: false,
    visibilityMap: {}
  }
};